module.exports = __webpack_public_path__ + "img/CI.5c2e60f7.png";